<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import api from "@/axios";
import exportFromJSON from "export-from-json";
import moment from "moment";
import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Mesas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Multiselect
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      mesaDataCodTransf: null,
      showTransferirMesa: false,
      mesaItensData: null,
      showModalMesa: false,
      submitMesaItem: false,
      ultPedsData: [],
      dtlistPesqMesaItem: null,
      mesaItemData: {},
      showModalMesaItem: false,
      loadingMesaItem: false,
      mesaData: {},
      statusFilter: 'T',
      pesqTextFilter: '',
      loadingList: true,
      mesasData: null,
      title: "Mesas",
      items: [
        {
          text: "Administrativo",
          href: "/",
        },
        {
          text: "Mesas",
          active: true,
        },
      ],
    };
  },
  mounted() {
    console.log('mounted mesas-list_0')
    this.atualizaDataList()
  },
  methods: {

    deletarItem(dataID){
      console.log('deletar: ' + dataID)
      this.showModalMesa = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/mesaitem`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })
    },

    novoLancamento(){
      this.showModalMesaItem = true
      this.mesaItemData = {}

    },

    confTransfMesa(){
      console.log('confTransfMesa')
      console.log(this.mesaDataCodTransf)
      this.showModalMesa = false

      if (this.mesaDataCodTransf){
        this.updating = true
        api.get(`${getBaseUrl()}api/mesatransf`, {
          params: {
            'coddata': this.mesaData.codigo,
            'codnovo': this.mesaDataCodTransf,
          }
        }).then((res) => {
          console.log('then axios transferir')
          console.log(res.data)

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações transferidas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.showTransferirMesa = false
          this.mesaDataCodTransf = null

          this.atualizaDataList()

        })
      }
    },


    cancelarMesa(){
      console.log('cancelarMesa')
      this.showModalMesa = false

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Mesa (" + this.mesaData.codigo + ")",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.get(`${getBaseUrl()}api/mesacanc`, {
            params: {
              'coddata': this.mesaData.codigo
            }
          }).then((res) => {
            console.log('then axios cancelar')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações canceladas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.atualizaDataList()

          })

        }
      })

    },


    selecionaMesa(mesaDataLoc){

      this.mesaData = mesaDataLoc
      console.log('mesaDataLoc')
      console.log(mesaDataLoc)

      api.get(`${getBaseUrl()}api/mesaitens`, {
        params: { coddata: mesaDataLoc.codigo }
      }).then((res) => {
        console.log('then axios mesa itens')
        console.log(res.data)
        // //console.log(res.data.length)
        this.mesaItensData = res.data[0]

        // this.dtlistPesqMesaItem.forEach((value) => {
        //   if (value.imgs){
        //     let imgTrat = value.imgs.split(',')
        //     value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
        //   }
        //
        // });

      })

      this.showModalMesa = true

    },

    nomeStatusMesa(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'A':
          result = 'Aberto'
          break
        case 'F':
          result = 'Fechado'
          break
        case 'X':
          result = 'Cancelado'
          break
      }
      return result
    },

    pesqMesaItem(evt){
      console.log('pesqMesaItem')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqMesaItem = null
        this.loadingMesaItem = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqMesaItem = res.data

          this.dtlistPesqMesaItem.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }

          });

        })
      }
    },

    escolheuMesaItem(){
      console.log('escolheuMesaItem')
      this.loadingMesaItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.mesaItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)

        let img1 = ''
        if (res.data[0]['imgs']){
          img1 = res.data[0]['imgs']
        }

        this.mesaItemData = {
          mesa_id: this.idData,
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          saldo: res.data[0]['saldo'],
          //img1: res.data[0]['imgs'],
          img1: img1,
          qtd: 1
        }
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingMesaItem = false
      })
    },


    confMesaItem(){
      console.log('confMesaItem: ' + this.idData)
      this.v$.$touch()
      this.submitMesaItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.loadingMesaItem = true

        api.post(`${getBaseUrl()}api/mesaitem`, {
          mesaItemData: this.mesaItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingMesaItem = false
          this.showModalMesaItem = false

          this.atualizaDataList()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          console.log(err.response)
          console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })

      }
    },


    exportExcel(){
      console.log('exportExcel')
      const data = this.mesasData
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/mesas`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data)
        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.mesasData = res.data[0]
          this.title = `(${this.mesasData.length}) Mesas em Aberto`
          this.loadingList = false
        }
      });
    },

    criarNova() {
      console.log('criarNova')
      this.$refs.childTable.setCriarNova(true)

    },

    calculaTotalItem(){
      console.log('calculaTotalItem')

      // let desc = this.mesaItemData.desconto
      let quant = this.mesaItemData.qtd
      let vlrUnit = this.mesaItemData.vlrunitliq
      let vlrUnitTab = this.mesaItemData.vlrunitbrt
      let percDesc = 0

      if (quant > 0 && vlrUnit > 0){

        console.log('valorTotalItem')
        console.log(valorTotalItem)

        if (vlrUnit !== vlrUnitTab){
          percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        }

        let valorTotalItem = quant * vlrUnit

        this.mesaItemData.desconto = percDesc
        this.mesaItemData.vlrtotalbrt = vlrUnitTab * quant
        this.mesaItemData.vlrtotalliq = valorTotalItem


        if (percDesc > 1000){
          this.messageValidacaoItem = 'Margem máxima de desconto atingida (30%), favor corrigir antes de confirmar'
        } else {
          this.messageValidacaoItem = ''
        }

      }

    },


    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    }

  },


  validations: {
    mesaItemData: {
      mesa: {
        required: helpers.withMessage("Campo mesa obrigatório, favor preencher.", required),
      },

      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },

  watch: {
    'mesaItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'mesaItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="loadingList" style="min-height: 400px;">
    </Loader>


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2" v-if="!loadingList">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="AB">Em Aberto</option>
                      <option value="CO">Concluso</option>
                      <option value="CA">Cancelado</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2" >

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatInteger(mesasData.length) }} (ativos) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Em Aberto:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Com Faturamento:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Cancelamento:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="exportExcel"
                       href="javascript: void(0);">
                      Exportar Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"

                       href="javascript: void(0);">
                      Relatório 001
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"

                       href="javascript: void(0);">
                      Relatório 002
                    </a>

                  </div>

                </b-dropdown>
              </div>



              <div class="col-sm-7">
                <div class="text-sm-end">


                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="novoLancamento">
                      <i class="mdi mdi-plus me-1"></i> Novo Lançamento
                    </button>


                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>




          </div>

        </div>
      </div>
    </div>

    <div class="row" v-if="!loadingList">
      <div v-for="mesa in mesasData" :key="mesa.id" class="col-xl-4 col-sm-6">

        <a href="javascript: void(0);" @click="selecionaMesa(mesa)">

          <div class="card">

            <div class="card-body">
              <div class="d-flex">


                <div class="avatar-md me-4">
                  <span
                      class="avatar-title rounded-circle bg-light text-danger font-size-16"
                  >
                    <img src="@/assets/images/mapa_mesas.png" alt height="30" />
                  </span>
                </div>

                <div class="flex-grow-1 overflow-hidden">

                  <h5 class="text-truncate font-size-15">
                    <span class="text-dark">
                       {{ mesa.descricao }} ({{ formatInteger(mesa.qtditens) }})
                    </span>
                  </h5>


                  <h5 class="text-truncate font-size-15">
                    <span class="text-dark">
                       Código: {{ mesa.codigo }}
                    </span>
                  </h5>

                  <p class="text-muted float-left me-3">
                    <span class="bx bx-star text-warning"></span>
                    <span class="bx bx-star text-warning ml-1"></span>
                    <span class="bx bx-star text-warning ml-1"></span>
                    <span class="bx bx-star text-warning ml-1"></span>
                    <span class="bx bx-star ml-1"></span>
                  </p>


                  <p class="text-muted mb-4"> {{ formatDateTime(mesa.created_at) }} </p>

                  <div class="avatar-group">

                    <div class="avatar-group-item">
                      <a href="javascript: void(0);"
                         class="d-inline-block">

                        <img src="@/assets/images/users/avatar-3.jpg"
                             class="rounded-circle avatar-xs"
                             alt />

                      </a>
                    </div>

                    <div class="avatar-group-item" >
                      <a href="javascript: void(0);"
                         class="d-inline-block">
                        <img src="@/assets/images/users/avatar-3.jpg"
                             class="rounded-circle avatar-xs"
                             alt/>

                      </a>
                    </div>

                    <div class="avatar-group-item">

                      <a href="javascript: void(0);"
                         class="d-inline-block">

                        <img src="@/assets/images/users/avatar-3.jpg"
                             class="rounded-circle avatar-xs"
                             alt/>

                      </a>

                    </div>

                  </div>
                </div>


              </div>
            </div>
            <div class="px-4 py-3 border-top">
              <ul class="list-inline mb-0">
                <li class="list-inline-item me-3">
                  <span class="badge"
                        :class="{ 'bg-warning': `${mesa.status}` === 'A',
                        'bg-success': `${mesa.status}` === 'F',
                        'bg-danger': `${mesa.status}` === 'X'
                  }">

                    {{ nomeStatusMesa(mesa.status) }}

                  </span>
                </li>

                <li class="list-inline-item me-3">
                  <span class="badge bg-danger">

                    Não Impresso

                  </span>
                </li>

                <li v-b-tooltip.hover.top
                    class="list-inline-item me-3 float-end"
                    title="Valor Total">

                  <i class="bx bx-money me-1"></i>
                  {{ formatDecimal(mesa.valor) }}
                </li>

<!--                <li v-b-tooltip.hover.top-->
<!--                    class="list-inline-item me-3"-->
<!--                    title="Interações">-->

<!--                  <i class="bx bx-comment-dots me-1"></i>-->
<!--                  {{ mesa.tipo }}-->
<!--                </li>-->


                <li v-b-tooltip.hover.top
                    v-if="mesa.priodia === 'A'"
                    class="list-inline-item me-3"
                    title="Interações">
                  <i class="bx bxs-bell-ring font-size-18 bx-fade-right text-danger"></i>
                </li>
              </ul>
            </div>
          </div>

        </a>

      </div>
    </div>
    <div class="row" v-if="!loadingList">
      <div class="col-lg-12">
        <ul
            class="pagination pagination-rounded justify-content-center mt-2 mb-5"
        >
          <li class="page-item disabled">
            <a href="#" class="page-link">
              <i class="mdi mdi-chevron-left"></i>
            </a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">1</a>
          </li>
          <li class="page-item active">
            <a href="#" class="page-link">2</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">3</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">4</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">5</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">
              <i class="mdi mdi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>



    <b-modal size="lg"
             title="Novo Lançamento de Produto em Mesa"
             v-model="showModalMesaItem"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Produto</span>

          <multiselect id="prodmesaitem"
                       ref="focusThis"
                       @search-change="pesqMesaItem"
                       @select="escolheuMesaItem"
                       v-model="mesaItemData.produto"
                       placeholder="Pesquisar produto"
                       :options="dtlistPesqMesaItem"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqMesaItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning" >
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end" >

                  </span>
                </div>

                <div class="align-items-end text-end align-content-end float-end">
                  <div v-if="!slotProps.option.img1" class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>
                  <div v-if="slotProps.option.img1">
                    <img class="rounded-circle avatar-xs" :src="slotProps.option.img1" alt />
                  </div>

                  <span class="float-end ">
                    <span v-if="slotProps.option.saldo > 0" class="avatar-title rounded-circle bg-success avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                  </span>
                </div>


              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div class="row" v-if="loadingMesaItem">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>



      <div v-if="!loadingMesaItem && mesaItemData.produto">


          <div class="row">

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">{{ mesaItemData.descprod }}</p>
                      <h5 class="mb-0">saldo: {{ formatInteger(mesaItemData.saldo) }} ({{ mesaItemData.und }})</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!mesaItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="mesaItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="mesaItemData.img1" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 155px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span class="text-info">   {{ mesaItemData.produto }} </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(mesaItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <form class="needs-validation" @submit.prevent="mesaItemData">
              <div class="row">

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="mesa">Mesa</label>
                    <input
                        id="mesa"
                        v-model="mesaItemData.mesa"
                        type="text"
                        class="form-control text-end"
                        placeholder="Código Mesa"
                        :class="{'is-invalid': submitMesaItem && v$.mesaItemData.mesa.$error,}"/>
                    <div v-if="submitMesaItem && v$.mesaItemData.mesa.$error"
                         class="invalid-feedback">
                      <span v-if="v$.mesaItemData.mesa.required.$message">{{ v$.mesaItemData.mesa.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="vlrunitliq">Valor Unitário</label>
                    <input
                        id="vlrunitliq"
                        v-model="mesaItemData.vlrunitliq"
                        type="number"
                        class="form-control text-end"
                        placeholder="Valor unitário líquido"
                        :class="{'is-invalid': submitMesaItem && v$.mesaItemData.vlrunitliq.$error,}"/>
                    <div v-if="submitMesaItem && v$.mesaItemData.vlrunitliq.$error"
                         class="invalid-feedback">
                      <span v-if="v$.mesaItemData.vlrunitliq.required.$message">{{ v$.mesaItemData.vlrunitliq.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="qtd">Quantidade</label>
                    <input
                        id="qtd"
                        v-model="mesaItemData.qtd"
                        type="number"
                        class="form-control text-end"
                        placeholder="Quantidade"
                        :class="{'is-invalid': submitMesaItem && v$.mesaItemData.qtd.$error,}"/>
                    <div v-if="submitMesaItem && v$.mesaItemData.qtd.$error"
                         class="invalid-feedback">
                      <span v-if="v$.mesaItemData.qtd.required.$message">{{ v$.mesaItemData.qtd.required.$message }}</span>
                    </div>
                  </div>
                </div>

              </div>

            </form>

            <!--            <div class="col-lg-6">-->
            <!--              <div class="card mini-stats-wid">-->
            <!--                <div class="card-body">-->
            <!--                  <div class="d-flex flex-wrap">-->
            <!--                    <div class="me-2">-->
            <!--                      <p class="text-muted mb-2">Preço concorrente 1</p>-->
            <!--                      <h5 class="mb-0">R$ {{ formatDecimal(138) }}</h5>-->
            <!--                    </div>-->
            <!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
            <!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
            <!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;                      </div>&ndash;&gt;-->
            <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="col-lg-6">-->
            <!--              <div class="card mini-stats-wid">-->
            <!--                <div class="card-body">-->
            <!--                  <div class="d-flex flex-wrap">-->
            <!--                    <div class="me-2">-->
            <!--                      <p class="text-muted mb-2">Preço concorrente 2</p>-->
            <!--                      <h5 class="mb-0">R$ {{ formatDecimal(125) }} </h5>-->
            <!--                    </div>-->
            <!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
            <!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
            <!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;                      </div>&ndash;&gt;-->
            <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->

          </div>


<!--        <router-link :to="`/cliente/detalhe/${mesaData.id}`" target="_blank" >-->
<!--          <p class="mb-2">-->
<!--            Código:-->
<!--            <span class="text-primary"> {{ mesaData.codigo }} </span>-->
<!--          </p>-->
<!--        </router-link>-->
<!--        <p class="mb-2" v-if="mesaData.cliender === 1">-->
<!--          <span class="text-muted" > Entregar: </span>-->
<!--          <span> {{ mesaData.rua }}, {{ mesaData.numero }}, {{ mesaData.bairro }}  </span>-->
<!--          <span> | </span>-->
<!--          <span> {{ mesaData.cidade }} - {{ mesaData.estado }} </span>-->
<!--        </p>-->

<!--        <p class="mb-2" v-if="mesaData.cliender === 2">-->
<!--          <span class="text-muted" > Entregar: </span>-->
<!--          <span> {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}, {{ pessoaEnderData.bairro1 }}  </span>-->
<!--          <span> | </span>-->
<!--          <span> {{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }} </span>-->
<!--        </p>-->

<!--        <p class="mb-2" v-if="mesaData.cliender === 3">-->
<!--          <span class="text-muted" > Entregar: </span>-->
<!--          <span> {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}, {{ pessoaEnderData.bairro2 }}  </span>-->
<!--          <span> | </span>-->
<!--          <span> {{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }} </span>-->
<!--        </p>-->

        <p class="mb-4" >



        </p>

<!--        <p class="mb-4" >-->
<!--          <span> {{ mesaData.tel1 }} / {{ mesaData.email }}</span>-->
<!--        </p>-->
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Pedidos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">0,00</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ 0,00</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ 0,00</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>



      <div v-if="mesaItemData.produto">
        <div class="text-start mt-5">

          <router-link :to="`/produto/editar/${mesaItemData.produto_id}`" target="_blank">
            <i class="bx bx-pencil font-size-16 align-middle me-2"></i>
            Alterar Cadastro de Produto
          </router-link>

        </div>
      </div>

      <div>
        <div class="text-start mt-3">
          <router-link  to="/produto/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Produto
          </router-link>

        </div>
      </div>


      <div v-if="!loadingMesaItem && mesaItemData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalMesaItem = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confMesaItem">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>





    <b-modal size="lg"
             :title="mesaData != null ? `Detalhes Mesa (${ mesaData.codigo })` : 'Detalhes Mesa'"
             v-model="showModalMesa"
             centered hide-footer>

        <div class="row">

          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body" style="min-height: 160px;">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">{{ mesaData.descricao }}</p>
                    <h5 class="mb-0">itens: {{ formatInteger(mesaData.qtditens) }} </h5>
                  </div>

                  <div class="me-2">
                    <p class="text-muted mb-2">Status: {{ nomeStatusMesa(mesaData.status) }}</p>
                    <h5 class="mb-0">Impresso:  </h5>
                  </div>

                  <div class="avatar-sm ms-auto" >
                    <div class="avatar-title bg-light rounded-circle text-primary">
                      <img class="rounded-circle avatar-xs" src="@/assets/images/mapa_mesas.png" alt style=""/>
                    </div>
                  </div>

<!--                  <div class="avatar-sm ms-auto">-->
<!--                    <div class="avatar-sm ms-auto">-->
<!--                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">-->
<!--                        <i class="bx bx-camera-off"></i>-->
<!--                      </div>-->
<!--                    </div>-->

<!--                    mapa_mesas.png-->

<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body" style="min-height: 155px;">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
<!--                    <span class="text-muted mb-2">Código: </span> <span class="text-info">   {{ mesaData.codigo }} </span>-->
                  </div>
                  <div class="">
                    <p class="text-muted mb-2">Valor Total em Aberto (Bruto)</p>
                    <h5 class="mb-0 mt-3">R$  {{ formatDecimal(mesaData.valor) }}</h5>
                  </div>
                  <div class="avatar-sm ms-auto">
                    <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                      <i class="bx bx-money"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


<!--          <form class="needs-validation" @submit.prevent="mesaItemData">-->
<!--            <div class="row">-->

<!--              <div class="col-md-6">-->
<!--                <div class="mb-3">-->
<!--                  <label for="mesa">Mesa</label>-->
<!--                  <input-->
<!--                      id="mesa"-->
<!--                      v-model="mesaItemData.mesa"-->
<!--                      type="text"-->
<!--                      class="form-control text-end"-->
<!--                      placeholder="Código Mesa"-->
<!--                      :class="{'is-invalid': submitMesaItem && v$.mesaItemData.mesa.$error,}"/>-->
<!--                  <div v-if="submitMesaItem && v$.mesaItemData.mesa.$error"-->
<!--                       class="invalid-feedback">-->
<!--                    <span v-if="v$.mesaItemData.mesa.required.$message">{{ v$.mesaItemData.mesa.required.$message }}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-md-6">-->
<!--                <div class="mb-3">-->
<!--                  <label for="vlrunitliq">Valor Unitário</label>-->
<!--                  <input-->
<!--                      id="vlrunitliq"-->
<!--                      v-model="mesaItemData.vlrunitliq"-->
<!--                      type="number"-->
<!--                      class="form-control text-end"-->
<!--                      placeholder="Valor unitário líquido"-->
<!--                      :class="{'is-invalid': submitMesaItem && v$.mesaItemData.vlrunitliq.$error,}"/>-->
<!--                  <div v-if="submitMesaItem && v$.mesaItemData.vlrunitliq.$error"-->
<!--                       class="invalid-feedback">-->
<!--                    <span v-if="v$.mesaItemData.vlrunitliq.required.$message">{{ v$.mesaItemData.vlrunitliq.required.$message }}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-md-6">-->
<!--                <div class="mb-3">-->
<!--                  <label for="qtd">Quantidade</label>-->
<!--                  <input-->
<!--                      id="qtd"-->
<!--                      v-model="mesaItemData.qtd"-->
<!--                      type="number"-->
<!--                      class="form-control text-end"-->
<!--                      placeholder="Quantidade"-->
<!--                      :class="{'is-invalid': submitMesaItem && v$.mesaItemData.qtd.$error,}"/>-->
<!--                  <div v-if="submitMesaItem && v$.mesaItemData.qtd.$error"-->
<!--                       class="invalid-feedback">-->
<!--                    <span v-if="v$.mesaItemData.qtd.required.$message">{{ v$.mesaItemData.qtd.required.$message }}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->

<!--          </form>-->

          <!--            <div class="col-lg-6">-->
          <!--              <div class="card mini-stats-wid">-->
          <!--                <div class="card-body">-->
          <!--                  <div class="d-flex flex-wrap">-->
          <!--                    <div class="me-2">-->
          <!--                      <p class="text-muted mb-2">Preço concorrente 1</p>-->
          <!--                      <h5 class="mb-0">R$ {{ formatDecimal(138) }}</h5>-->
          <!--                    </div>-->
          <!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
          <!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
          <!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;                      </div>&ndash;&gt;-->
          <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->

          <!--            <div class="col-lg-6">-->
          <!--              <div class="card mini-stats-wid">-->
          <!--                <div class="card-body">-->
          <!--                  <div class="d-flex flex-wrap">-->
          <!--                    <div class="me-2">-->
          <!--                      <p class="text-muted mb-2">Preço concorrente 2</p>-->
          <!--                      <h5 class="mb-0">R$ {{ formatDecimal(125) }} </h5>-->
          <!--                    </div>-->
          <!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
          <!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
          <!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;                      </div>&ndash;&gt;-->
          <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->

        </div>


        <!--        <router-link :to="`/cliente/detalhe/${mesaData.id}`" target="_blank" >-->
        <!--          <p class="mb-2">-->
        <!--            Código:-->
        <!--            <span class="text-primary"> {{ mesaData.codigo }} </span>-->
        <!--          </p>-->
        <!--        </router-link>-->
        <!--        <p class="mb-2" v-if="mesaData.cliender === 1">-->
        <!--          <span class="text-muted" > Entregar: </span>-->
        <!--          <span> {{ mesaData.rua }}, {{ mesaData.numero }}, {{ mesaData.bairro }}  </span>-->
        <!--          <span> | </span>-->
        <!--          <span> {{ mesaData.cidade }} - {{ mesaData.estado }} </span>-->
        <!--        </p>-->

        <!--        <p class="mb-2" v-if="mesaData.cliender === 2">-->
        <!--          <span class="text-muted" > Entregar: </span>-->
        <!--          <span> {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}, {{ pessoaEnderData.bairro1 }}  </span>-->
        <!--          <span> | </span>-->
        <!--          <span> {{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }} </span>-->
        <!--        </p>-->

        <!--        <p class="mb-2" v-if="mesaData.cliender === 3">-->
        <!--          <span class="text-muted" > Entregar: </span>-->
        <!--          <span> {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}, {{ pessoaEnderData.bairro2 }}  </span>-->
        <!--          <span> | </span>-->
        <!--          <span> {{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }} </span>-->
        <!--        </p>-->

        <p class="mb-4" >



        </p>

        <!--        <p class="mb-4" >-->
        <!--          <span> {{ mesaData.tel1 }} / {{ mesaData.email }}</span>-->
        <!--        </p>-->
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Produto</th>
              <th scope="col" class="text-end">Quantidade</th>
              <th scope="col" class="text-end">Valor Un.</th>
              <th scope="col" class="text-end">Valor Total</th>
              <th scope="col" class="text-end">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in mesaItensData" :key="data.id">
              <td>
                <router-link :to="`/produto/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.produto }}
                    </h5>
                  </div>
                </router-link>
              </td>

              <td>
                <router-link :to="`/produto/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.descprod }}
                    </h5>
                  </div>
                </router-link>
              </td>

              <td class="text-end"> {{ formatDecimal(data.qtd) }} </td>
              <td class="text-end"> {{ formatDecimal(data.vlrunitliq) }} </td>
              <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

              <td class="text-end">
                <!--                <div class="button-items">-->
                <!--            <b-button variant="outline-success" @click="editar(data.id)">-->
                <!--              <i class="mdi mdi-pencil d-block font-size-16"></i>-->
                <!--            </b-button>-->


                <!--                  <b-button variant="outline-success" @click="detalhes(data.id)">-->
                <!--                    <i class="mdi mdi-eye d-block font-size-16"></i>-->
                <!--                  </b-button>-->

                <!--                  <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">-->
                <!--                    <i class="mdi mdi-pencil d-block font-size-16"></i>-->
                <!--                  </b-button>-->

                <b-button variant="outline-danger" @click="deletarItem(data.id)">
                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                </b-button>

                <!--                </div>-->
              </td>

            </tr>
            <tr>
              <td colspan="5">
                <h6 class="m-0 text-end">Valor Total Produtos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(mesaData.valor) }}</td>



            </tr>
<!--            <tr>-->
<!--              <td colspan="4">-->
<!--                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>-->
<!--              </td>-->
<!--              <td class="font-size-14 text-end">R$ 0,00</td>-->
<!--            </tr>-->
            </tbody>
          </table>
        </div>







      <div v-if="mesaData && mesaData.status === 'A'">
        <div class="text-start mt-5">
          <a href="javascript: void(0);" @click="showTransferirMesa = !showTransferirMesa" >
            <i class="bx bx-upload font-size-16 align-middle me-2"></i>
            Transferir Para outra Mesa
          </a>
        </div>
      </div>

      <div v-if="showTransferirMesa">
        <div class="mb-2 mt-2">
          <label>Código Nova Mesa:</label>
          <div class="row">
            <div class="col-xl-4 col-sm-4">

              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                      id="codtransf"
                      v-model="mesaDataCodTransf"
                      type="text"
                      class="form-control text-end"
                      placeholder="Código Nova Mesa"/>
                </label>
              </div>
            </div>

            <div class="col-xl-4 col-sm-4">

              <div class="mb-3">

                <b-button type="button" variant="success" class="ms-1" @click="confTransfMesa">
                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                  Confirmar
                </b-button>
              </div>


            </div>




          </div>
        </div>

      </div>


      <div v-if="mesaData && mesaData.status === 'A'">
        <div class="text-start mt-3">
          <a href="javascript: void(0);" class="text-body" @click="cancelarMesa">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar Todos os Produtos
          </a>
        </div>
      </div>


      <div v-if="!loadingMesaItem && mesaItemData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalMesa = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confMesaItem" v-if="mesaData.valor > 0">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Faturamento
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>
